// extracted by mini-css-extract-plugin
export default {"wrapper":"NoteNav_wrapper__yIA3R","notenav":"NoteNav_notenav__on2Wa","otherbuttons":"NoteNav_otherbuttons__JZ28w","button":"NoteNav_button__CTvLl"};